import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PrimaryTradeForm } from 'src/app/classes/form-groups/primary-trade-form';
import { TradeCategoryForm } from 'src/app/classes/form-groups/trade-category-form';
import { PrimaryTrade, TradeCategory } from 'src/app/classes/models';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-add-edit-trade-category',
  templateUrl: './add-edit-trade-category.component.html',
  styleUrl: './add-edit-trade-category.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditTradeCategoryComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private UtilityService: UtilityService,
    private ToastService: ToastService
  ) {}

  @Input() TradeCategory?: TradeCategory;

  tradeCategoryForm: TradeCategoryForm = new TradeCategoryForm();

  close(reason?: string) {
    this.activeModal.dismiss(reason);
  }

  save() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.tradeCategoryForm
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save. Form has errors.',
        { returnError: true }
      );
    }

    if (!this.TradeCategory) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save. No Trade Category found.',
        { returnError: true }
      );
    }

    Object.assign(this.TradeCategory, this.tradeCategoryForm.getRawValue());

    this.activeModal.close();
  }

  ngOnInit(): void {
    if (this.TradeCategory) {
      this.tradeCategoryForm.patchValue(this.TradeCategory);
    }
  }
}
